import React from "react";
import { useLocation, useHistory } from "react-router-dom";

const URLOrdoMyLab = ({ changeFilterInput, openNewFolder }) => {
	const sampleLocation = useLocation();
	let history = useHistory();
	React.useEffect(() => {
		if (sampleLocation.pathname && sampleLocation.pathname.indexOf("home/lab/ORDO_MYLAB_") > -1) {
			let mylabOrdo = sampleLocation.pathname.substring(10);
			history.push("/home/lab");
			changeFilterInput(mylabOrdo);
		}
		if (sampleLocation.pathname && sampleLocation.pathname.indexOf("home/lab/preregister_") > -1) {
			let qrCode = sampleLocation.pathname.substring(22);
			history.push("/home/lab");
			changeFilterInput(qrCode);
		}
		if (sampleLocation.pathname && sampleLocation.pathname.indexOf("home/lab/patient_") > -1) {
			let params = sampleLocation.pathname.substring(18);
			if (params.indexOf("-") > -1) {
				params = params.split("-");
			}
			history.push("/home/lab");
			openNewFolder(typeof params === "object" ? params[0] : params, typeof params === "object" ? params[1] : null);
		}
	}, [sampleLocation]);

	return <> </>;
};

export default URLOrdoMyLab;
